package com.rosario.juridico.marketplace.billing

/**
 * En la Web (JS), el sistema de facturación de Google Play no está disponible.
 * Devolvemos null para que la UI se comporte de forma acorde (por ejemplo, ocultando opciones de suscripción).
 */
actual fun getBillingProvider(): BillingProvider? = null
